import React from 'react';
import { Card } from 'react-bootstrap';
import { FaArrowUp, FaArrowDown, FaMinus } from 'react-icons/fa';

// Targeta d'estadística del dashboard (Home); mostra un comptador d'ofertes per etapa.
// Els CallAgents (no superadmin) només veuen "Solicitud Oferta"; els superadmins veuen totes les etapes.
const StatCard = ({ title, value, icon: Icon, trend, trendValue, color = "primary" }) => {
    // Map abstract color names to our CSS variables
    const getColorVar = (c) => {
        switch (c) {
            case 'primary': return 'var(--ab-primary)';
            case 'success': return 'var(--ab-primary-light)'; // Use our Green
            case 'info': return 'var(--ab-info)';
            case 'warning': return 'var(--ab-warning)';
            default: return 'var(--ab-primary)';
        }
    };

    const iconColor = getColorVar(color);

    return (
        <Card className="h-100 border-0 shadow rounded-4 overflow-hidden">
            <Card.Body className="d-flex align-items-center justify-content-between p-4">
                <div>
                    <h6 className="text-muted text-uppercase fw-bold mb-2 small">
                        {title}
                    </h6>
                    <h2 className="mb-0 fw-bold" style={{ color: 'var(--ab-text-primary)' }}>
                        {value}
                    </h2>
                    {trend && (
                        <div className="mt-2 d-flex align-items-center small">
                            {trend === 'up' && <span className="text-success fw-bold"><FaArrowUp className="me-1" />{trendValue}</span>}
                            {trend === 'down' && <span className="text-danger fw-bold"><FaArrowDown className="me-1" />{trendValue}</span>}
                            {trend === 'neutral' && <span className="text-muted"><FaMinus className="me-1" />{trendValue}</span>}
                        </div>
                    )}
                </div>
                <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                        width: '60px',
                        height: '60px',
                        fontSize: '1.5rem',
                        color: iconColor,
                        backgroundColor: 'rgba(var(--bs-primary-rgb), 0.1)' // Using bootstrap var if available, else standard opacity
                    }}
                >
                    <Icon />
                </div>
            </Card.Body>
        </Card>
    );
};

export default StatCard;
